import { LazyDashboardPage as DashboardPage } from 'pages/DashboardPage/LazyDashboardPage';
import { EPageComponentTypes } from 'models/route';
import { AuthPage } from 'pages/AuthPage';
import { lazyPage } from 'utils/lazyPage';

const TableTestPage = lazyPage(() => import('pages/TableTestPage'), 'TableTestPage');
const LegalEntitiesPage = lazyPage(() => import('pages/LegalEntitiesPage'));
const FirearmsPage = lazyPage(() => import('pages/Firearms'));
const ViewRegisteredFirearmPage = lazyPage(
  () => import('pages/Firearms/ViewRegisteredFirearmPage'),
  'ViewRegisteredFirearmPage',
);
const EditRegisteredFirearmPage = lazyPage(
  () => import('pages/Firearms/EditRegisteredFirearmPage'),
  'EditRegisteredFirearmPage',
);
const RegisteredFirearmAddCommentPage = lazyPage(
  () => import('pages/Firearms/RegisteredFirearmAddCommentPage'),
  'RegisteredFirearmAddCommentPage',
);
const RegisteredFirearmDeleteCommentPage = lazyPage(
  () => import('pages/Firearms/RegisteredFirearmDeleteCommentPage'),
  'RegisteredFirearmDeleteCommentPage',
);
const RegisteredFirearmAddAttachmentPage = lazyPage(
  () => import('pages/Firearms/RegisteredFirearmAddAttachmentPage'),
  'RegisteredFirearmAddAttachmentPage',
);
const RegisteredFirearmDeleteAttachmentPage = lazyPage(
  () => import('pages/Firearms/RegisteredFirearmDeleteAttachmentPage'),
  'RegisteredFirearmDeleteAttachmentPage',
);
const TransactionsPage = lazyPage(() => import('pages/TransactionsPage'));
const UsersPage = lazyPage(() => import('pages/UsersPage'));
const AddUserPage = lazyPage(() => import('pages/UsersPage/AddUserPage'), 'AddUserPage');
const RolesPage = lazyPage(() => import('pages/RolesPage'));
const DictionariesPage = lazyPage(() => import('pages/DictionariesPage'));
const ViewDictionaryPage = lazyPage(() => import('pages/DictionariesPage/ViewDictionaryPage'));
const AddDictionaryValuePage = lazyPage(
  () => import('pages/DictionariesPage/ViewDictionaryPage/AddDictionaryValuePage'),
  'AddDictionaryValuePage',
);
const EditDictionaryValuePage = lazyPage(
  () => import('pages/DictionariesPage/ViewDictionaryPage/EditDictionaryValuePage'),
  'EditDictionaryValuePage',
);
const AdministrationPage = lazyPage(() => import('pages/AdministrationPage'));
const GeneralLicenceSettingsPage = lazyPage(() => import('pages/GeneralLicenceSettingsPage'));
const DateTimeSetupPage = lazyPage(() => import('pages/SystemSettingsPage/DateTimeSetupPage'));
const NotificationsSetupPage = lazyPage(
  () => import('pages/SystemSettingsPage/NotificationsSetupPage'),
);
const NotificationsPage = lazyPage(() => import('pages/NotificationsPage'));
const StyleGuidePage = lazyPage(() => import('pages/StyleGuidePage'), 'StyleGuidePage');
const AddRolePage = lazyPage(() => import('pages/RolesPage/AddRolePage'), 'AddRolePage');
const ForgotPasswordPage = lazyPage(
  () => import('pages/ForgotPasswordPage'),
  'ForgotPasswordPage',
);
const ResetPasswordPage = lazyPage(
  () => import('pages/ResetPasswordPage'),
  'ResetPasswordPage',
);
const EditRolePage = lazyPage(() => import('pages/RolesPage/EditRolePage'), 'EditRolePage');
const ViewRolePage = lazyPage(() => import('pages/RolesPage/ViewRolePage'), 'ViewRolePage');
const DeleteRolePage = lazyPage(
  () => import('pages/RolesPage/DeleteRolePage'),
  'DeleteRolePage',
);
const AncillariesPage = lazyPage(() => import('pages/AncillariesPage'));
const AddAncillariesReference = lazyPage(
  () => import('pages/AncillariesPage/AncillariesReferenceTablePage/AddAncillariesReference'),
);
const EditAncillariesReference = lazyPage(
  () => import('pages/AncillariesPage/AncillariesReferenceTablePage/EditAncillariesReference'),
);
const AddLegalEntityPage = lazyPage(
  () => import('pages/LegalEntitiesPage/AddLegalEntityPage'),
  'AddLegalEntityPage',
);
const EditLegalEntityPage = lazyPage(
  () => import('pages/LegalEntitiesPage/EditLegalEntityPage'),
  'EditLegalEntityPage',
);
const DeleteLegalEntityPage = lazyPage(
  () => import('pages/LegalEntitiesPage/DeleteLegalEntityPage'),
  'DeleteLegalEntityPage',
);
const ViewLegalEntityPage = lazyPage(
  () => import('pages/LegalEntitiesPage/ViewLegalEntityPage'),
  'ViewLegalEntityPage',
);
const LegalEntityAddCommentPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddCommentPage'),
  'LegalEntityAddCommentPage',
);
const LegalEntityDeleteCommentPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityDeleteCommentPage'),
  'LegalEntityDeleteCommentPage',
);
const AccountPage = lazyPage(() => import('pages/AccountPage'), 'AccountPage');
const LegalEntityAddAddressPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddAddressPage'),
  'LegalEntityAddAddressPage',
);
const LegalEntityEditAddressPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityEditAddressPage'),
  'LegalEntityEditAddressPage',
);
const LegalEntityDeleteAddressPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityDeleteAddressPage'),
  'LegalEntityDeleteAddressPage',
);
const LegalEntityAddAttachmentPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddAttachmentPage'),
  'LegalEntityAddAttachmentPage',
);
const LegalEntityEditContactPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityEditContactPage'),
  'LegalEntityEditContactPage',
);
const LegalEntityDeleteContactPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityDeleteContactPage'),
  'LegalEntityDeleteContactPage',
);
const LegalEntityAddContactPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddContactPage'),
  'LegalEntityAddContactPage',
);
const ViewLegalEntityGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/ViewLegalEntityGroupPage'),
  'ViewLegalEntityGroupPage',
);
const LegalEntityGroupAddFirearmPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityGroupAddFirearmPage'),
  'LegalEntityGroupAddFirearmPage',
);
const LegalEntityAddGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddGroupPage'),
  'LegalEntityAddGroupPage',
);
const LegalEntityDeleteGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityDeleteGroupPage'),
  'LegalEntityDeleteGroupPage',
);
const LegalEntityEditGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityEditGroupPage'),
  'LegalEntityEditGroupPage',
);
const RemoveDevicePage = lazyPage(
  () => import('pages/AccountPage/RemoveDevicePage'),
  'RemoveDevicePage',
);
const ChangePasswordPage = lazyPage(
  () => import('pages/AccountPage/ChangePasswordPage'),
  'ChangePasswordPage',
);
const EditAccountPage = lazyPage(
  () => import('pages/AccountPage/EditAccountPage'),
  'EditAccountPage',
);
const ViewUserPage = lazyPage(() => import('pages/UsersPage/ViewUserPage'), 'ViewUserPage');
const EditUserStatusPage = lazyPage(
  () => import('pages/UsersPage/EditUserStatusPage'),
  'EditUserStatusPage',
);
const AssignLESearchPage = lazyPage(() => import('pages/UsersPage/AssignLESearchPage'));
const AssignLEPage = lazyPage(() => import('pages/UsersPage/AssignLEPage'), 'AssignLEPage');
const EditUserPage = lazyPage(() => import('pages/UsersPage/EditUserPage'), 'EditUserPage');
const GeneratePasswordUserPage = lazyPage(
  () => import('pages/UsersPage/GeneratePasswordUserPage'),
  'GeneratePasswordUserPage',
);
const DeleteAssignedLEPage = lazyPage(
  () => import('pages/UsersPage/DeleteAssignedLEPage'),
  'DeleteAssignedLEPage',
);
const LegalEntityGroupFirearmSearchPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityGroupFirearmSearchPage'),
  'LegalEntityGroupFirearmSearchPage',
);
const SavePresetPage = lazyPage(
  () => import('pages/LegalEntitiesPage/SavePresetPage'),
  'SavePresetPage',
);
const MyFiltersPage = lazyPage(() => import('pages/MyFiltersPage'), 'MyFiltersPage');
const DeleteFilterPage = lazyPage(
  () => import('pages/MyFiltersPage/DeleteFilterPage'),
  'DeleteFilterPage',
);
const LegalEntityAddFirearmPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddFirearmPage'),
  'LegalEntityAddFirearmPage',
);
const LegalEntityAddAncillaryPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddAncillaryPage'),
  'LegalEntityAddAncillaryPage',
);
const LegalEntityAddTransactionForGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddTransactionForGroupPage'),
  'LegalEntityAddTransactionForGroupPage',
);
const SearchForFRTFirearmPage = lazyPage(
  () => import('pages/Transactions/SearchForFRTFirearmPage'),
);
const SearchForARTAncillaryPage = lazyPage(
  () => import('pages/Transactions/SearchForARTAncillaryPage'),
);
const FRTFirearmDetailsPage = lazyPage(
  () => import('pages/Transactions/FRTFirearmDetailsPage'),
  'FRTFirearmDetailsPage',
);
const RegisteredFirearmsMapPage = lazyPage(
  () => import('pages/Firearms/RegisteredFirearmsMapPage'),
  'RegisteredFirearmsMapPage',
);
const SaveFirearmsPresetPage = lazyPage(
  () => import('pages/Firearms/SaveFirearmsPresetPage'),
  'SaveFirearmsPresetPage',
);
const FRTDetailsPage = lazyPage(() => import('pages/FRT/FRTDetailsPage'), 'FRTDetailsPage');
const FRTEditPage = lazyPage(() => import('pages/FRT/FRTEditPage'), 'FRTEditPage');
const FRTAddCalibrePage = lazyPage(
  () => import('pages/FRT/FRTAddCalibrePage'),
  'FRTAddCalibrePage',
);
const FRTEditCalibrePage = lazyPage(
  () => import('pages/FRT/FRTEditCalibrePage'),
  'FRTEditCalibrePage',
);
const SelectLegalEntityPage = lazyPage(
  () => import('pages/LegalEntitiesPage/SelectLegalEntityPage'),
  'SelectLegalEntityPage',
);
const SelectLocationPage = lazyPage(
  () => import('pages/Transactions/SelectLocationPage'),
  'SelectLocationPage',
);
const FRTAddPage = lazyPage(() => import('pages/FRT/FRTAddPage'), 'FRTAddPage');
const ViewTransactionPage = lazyPage(
  () => import('pages/TransactionsPage/ViewTransactionPage'),
);
const CancelTransactionPage = lazyPage(
  () => import('pages/TransactionsPage/CancelTransactionPage'),
);
const TransactionAddCommentPage = lazyPage(
  () => import('pages/TransactionsPage/TransactionAddCommentPage'),
  'TransactionAddCommentPage',
);
const TransactionDeleteCommentPage = lazyPage(
  () => import('pages/TransactionsPage/TransactionDeleteCommentPage'),
  'TransactionDeleteCommentPage',
);
const SaveTransactionPresetPage = lazyPage(
  () => import('pages/TransactionsPage/SaveTransactionPresetPage'),
  'SaveTransactionPresetPage',
);
const ViewNotificationPage = lazyPage(
  () => import('pages/NotificationsPage/ViewNotificationPage'),
  'ViewNotificationPage',
);
const DisableRegisteredFirearmPage = lazyPage(
  () => import('pages/Firearms/DisableRegisteredFirearmPage'),
  'DisableRegisteredFirearmPage',
);
const DashboardSearchResultsPage = lazyPage(() => import('pages/DashboardSearchResultsPage'));
const CustomFieldsPage = lazyPage(() => import('pages/CustomFieldsPage'));
const AddCustomFieldPage = lazyPage(() => import('pages/CustomFieldsPage/AddCustomFieldPage'));
const ToggleCustomFieldPage = lazyPage(
  () => import('pages/CustomFieldsPage/ToggleCustomFieldPage'),
);
const EditCustomFieldPage = lazyPage(
  () => import('pages/CustomFieldsPage/EditCustomFieldPage'),
);
const NotFoundPage = lazyPage(() => import('pages/NotFoundPage'), 'NotFoundPage');
const AccessDeniedPage = lazyPage(() => import('pages/AccessDeniedPage'), 'AccessDeniedPage');
const ServerErrorPage = lazyPage(() => import('pages/ServerErrorPage'), 'ServerErrorPage');
const DetailAncillariesReference = lazyPage(
  () =>
    import('pages/AncillariesPage/AncillariesReferenceTablePage/DetailAncillariesReference'),
);
const AuditLogPage = lazyPage(() => import('pages/AuditLogPage'));
const AuthenticationSetupPage = lazyPage(
  () => import('pages/SystemSettingsPage/AuthenticationSetupPage'),
);
const DetailAccessories = lazyPage(
  () => import('pages/AncillariesPage/AccessoriesPage/DetailAccessories'),
);
const DetailComponents = lazyPage(
  () => import('pages/AncillariesPage/ComponentsPage/DetailComponents'),
);
const DetailAmmunition = lazyPage(
  () => import('pages/AncillariesPage/AmmunitionPage/DetailAmmunition'),
);
const AuditLogViewPage = lazyPage(() => import('pages/AuditLogPage/AuditLogViewPage'));
const ViewRegisteredFirearmAttachment = lazyPage(
  () => import('pages/Firearms/ViewRegisteredFirearmAttachment'),
  'ViewRegisteredFirearmAttachment',
);
const AccessoriesDeleteCommentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AccessoriesPage/DetailAccessories/AccessoriesDeleteCommentPage'),
  'AccessoriesDeleteCommentPage',
);
const AccessoriesAddCommentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AccessoriesPage/DetailAccessories/AccessoriesAddCommentPage'),
  'AccessoriesAddCommentPage',
);
const AccessoriesAddAttachmentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AccessoriesPage/DetailAccessories/AccessoriesAddAttachmentPage'),
  'AccessoriesAddAttachmentPage',
);
const AccessoriesAttachmentViewPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AccessoriesPage/DetailAccessories/AccessoriesAttachmentViewPage'),
  'AccessoriesAttachmentViewPage',
);
const AccessoriesDeleteAttachmentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AccessoriesPage/DetailAccessories/AccessoriesDeleteAttachmentPage'),
  'AccessoriesDeleteAttachmentPage',
);
const ComponentsDeleteCommentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/ComponentsPage/DetailComponents/ComponentsDeleteCommentPage'),
  'ComponentsDeleteCommentPage',
);
const ComponentsAddCommentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/ComponentsPage/DetailComponents/ComponentsAddCommentPage'),
  'ComponentsAddCommentPage',
);
const ComponentsAddAttachmentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/ComponentsPage/DetailComponents/ComponentsAddAttachmentPage'),
  'ComponentsAddAttachmentPage',
);
const ComponentsAttachmentViewPage = lazyPage(
  () =>
    import('pages/AncillariesPage/ComponentsPage/DetailComponents/ComponentsAttachmentViewPage'),
  'ComponentsAttachmentViewPage',
);
const ComponentsDeleteAttachmentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/ComponentsPage/DetailComponents/ComponentsDeleteAttachmentPage'),
  'ComponentsDeleteAttachmentPage',
);
const RegisteredAncillariesMapPage = lazyPage(
  () => import('pages/AncillariesPage/AncillariesMap'),
  'RegisteredAncillariesMapPage',
);
const SaveAncillariesPresetPage = lazyPage(
  () => import('pages/AncillariesPage/SaveAncillariesPresetPage/SaveAncillariesPresetPage'),
  'SaveAncillariesPresetPage',
);
const AmmunitionDeleteCommentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AmmunitionPage/DetailAmmunition/AmmunitionDeleteCommentPage'),
  'AmmunitionDeleteCommentPage',
);
const AmmunitionAddCommentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AmmunitionPage/DetailAmmunition/AmmunitionAddCommentPage'),
  'AmmunitionAddCommentPage',
);
const AmmunitionAddAttachmentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AmmunitionPage/DetailAmmunition/AmmunitionAddAttachmentsPage'),
  'AmmunitionAddAttachmentPage',
);
const AmmunitionAttachmentsViewPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AmmunitionPage/DetailAmmunition/AmmunitionAttachmentViewPage'),
  'AmmunitionAttachmentsViewPage',
);
const AmmunitionDeleteAttachmentPage = lazyPage(
  () =>
    import('pages/AncillariesPage/AmmunitionPage/DetailAmmunition/AmmunitionDeleteAttachmentPage'),
  'AmmunitionDeleteAttachmentPage',
);
const AncillariesAddTransactionPage = lazyPage(
  () => import('pages/AncillariesPage/AncillariesAddTransactionPage'),
);
const DisableAncillaryPage = lazyPage(
  () => import('pages/AncillariesPage/DisableAncillaryPage'),
);
const EditAncillaryPage = lazyPage(() => import('pages/AncillariesPage/EditAncillaryPage'));
const LicencePage = lazyPage(() => import('pages/LicenceDetailsPage'), 'LicencePage');
const LegalEntityAddAncillaryGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddAncillaryGroupPage'),
  'LegalEntityAddAncillaryGroupPage',
);
const LegalEntityAddAncillaryGroupSearchPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddAncillaryGroupSearchPage'),
);
const LegalEntityEditAncillaryGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityEditAncillaryGroupPage'),
  'LegalEntityEditAncillaryGroupPage',
);
const LegalEntityDeleteAncillariesGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityDeleteAncillariesGroupPage'),
  'LegalEntityDeleteAncillariesGroupPage',
);
const ViewLegalEntityAncillaryGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/ViewLegalEntityAncillaryGroupPage'),
  'ViewLegalEntityAncillaryGroupPage',
);
const ApiKeysPage = lazyPage(() => import('pages/ApiKeysPage'));
const AddApiKeyPage = lazyPage(() => import('pages/ApiKeysPage/AddApiKeyPage'));
const EditApiKeyPage = lazyPage(() => import('pages/ApiKeysPage/EditApiKeyPage'));
const ViewApiKeyPage = lazyPage(() => import('pages/ApiKeysPage/ViewApiKeyPage'));
const DeleteApiKeyPage = lazyPage(() => import('pages/ApiKeysPage/DeleteApiKeyPage'));
const LegalEntityAddTransactionForAncillaryGroupPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddTransactionForAncillaryGroupPage'),
);
const ReplaceLicencePage = lazyPage(
  () => import('pages/LicenceDetailsPage/ReplaceLicencePage'),
);
const StartLicencePage = lazyPage(() => import('pages/StartLicencePage'));
const LogoSetupPage = lazyPage(() => import('pages/SystemSettingsPage/LogoSetupPage'));
const DocumentsGeneratingSetupPage = lazyPage(
  () => import('pages/SystemSettingsPage/DocumentsGeneratingSetupPage'),
  'DocumentsGeneratingSetupPage',
);
const DeleteUserPage = lazyPage(
  () => import('pages/UsersPage/DeleteUserPage'),
  'DeleteUserPage',
);
const LegalEntityGroupDeleteFirearmPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityGroupDeleteFirearmPage'),
  'LegalEntityGroupDeleteFirearmPage',
);
const LegalEntityGroupDeleteAncillaryPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityGroupDeleteAncillaryPage'),
  'LegalEntityGroupDeleteAncillaryPage',
);
const MovedTransactionPage = lazyPage(
  () => import('pages/TransactionsPage/MovedTransactionPage'),
  'MovedTransactionPage',
);
const LicenceConfigurationPage = lazyPage(
  () => import('pages/LicenceConfigurationPage'),
  'LicenceConfigurationPage',
);
const AddLicenceTemplatePage = lazyPage(
  () => import('pages/LicenceConfigurationPage/AddLicenceTemplatePage'),
  'AddLicenceTemplatePage',
);
const ResetUserOfflineAuth = lazyPage(
  () => import('pages/UsersPage/ResetUserOfflineAuth'),
  'ResetUserOfflineAuth',
);
const LicenceTemplatePage = lazyPage(
  () => import('pages/LicenceConfigurationPage/LicenceTemplatePage'),
  'LicenceTemplatePage',
);
const EditLicenceTemplatePage = lazyPage(
  () => import('pages/LicenceConfigurationPage/EditLicenceTemplatePage'),
  'EditLicenceTemplatePage',
);
const CalendarPage = lazyPage(() => import('pages/CalendarPage'));
const LicencesTabsPage = lazyPage(() => import('pages/LicencesPage'));
const PrintoutBatchDetails = lazyPage(
  () => import('pages/LicencesPage/PrintoutBatchDetails'),
  'PrintoutBatchDetails',
);
const PrintoutDetails = lazyPage(
  () => import('pages/LicencesPage/PrintoutDetails'),
  'PrintoutDetails',
);
const LegalEntityLicencePage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityLicencePage'),
  'LegalEntityLicencePage',
);
const UnitsCurrencySetupPage = lazyPage(
  () => import('pages/SystemSettingsPage/UnitsCurrencySetupPage'),
  'UnitsCurrencySetupPage',
);
const LegalEntityViewLicencePage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityViewLicencePage'),
  'LegalEntityViewLicencePage',
);
const LegalEntityAddPreviousNamesSurnamesPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityAddPreviousNamesSurnamesPage'),
  'LegalEntityAddPreviousNamesSurnamesPage',
);
const LegalEntityEditPreviousNamesSurnamesPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityEditPreviousNamesSurnamesPage'),
  'LegalEntityEditPreviousNamesSurnamesPage',
);
const LegalEntityDeletePreviousNamesSurnamesPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityDeletePreviousNamesSurnamesPage'),
  'LegalEntityDeletePreviousNamesSurnamesPage',
);
const LegalEntityLicenceLinkWeaponPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityLicenceLinkWeaponPage'),
  'LegalEntityLicenceLinkWeaponPage',
);
const LicenceTemplateAddApplicationProcessPage = lazyPage(
  () => import('pages/LicenceConfigurationPage/LicenceTemplateAddApplicationProcessPage'),
  'LicenceTemplateAddApplicationProcessPage',
);
const LegalEntityLicenceVaryPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityLicenceVaryPage'),
  'LegalEntityLicenceVaryPage',
);
const ViewLegalEntityAddressMapPage = lazyPage(
  () => import('pages/LegalEntitiesPage/ViewLegalEntityAddressMapPage'),
  'ViewLegalEntityAddressMapPage',
);
const LegalEntityLicenceRenewPage = lazyPage(
  () => import('pages/LegalEntitiesPage/LegalEntityLicenceRenewPage'),
  'LegalEntityLicenceRenewPage',
);
const SaveLicencePresetPage = lazyPage(
  () => import('pages/LicencesPage/SaveLicencePresetPage'),
  'SaveLicencePresetPage',
);
const ManageImagesTemplate = lazyPage(
  () => import('components/templates/ManageImagesTemplate'),
  'ManageImagesTemplate',
);
const LicenceTemplateApplicationProcessPage = lazyPage(
  () => import('pages/LicenceConfigurationPage/LicenceTemplateApplicationProcessPage'),
  'LicenceTemplateApplicationProcessPage',
);
const LicenceTemplateEditApplicationProcessPage = lazyPage(
  () => import('pages/LicenceConfigurationPage/LicenceTemplateEditApplicationProcessPage'),
  'LicenceTemplateEditApplicationProcessPage',
);
const CaseManagementPage = lazyPage(() => import('pages/CaseManagementPage'));
const CaseDetailsPage = lazyPage(
  () => import('pages/CaseManagementPage/CasesPage/CaseDetailsPage'),
);
const AddIntelligenceReport = lazyPage(
  () =>
    import('pages/CaseManagementPage/CasesPage/CaseDetailsPage/IntelligenceReport/AddIntelligenceReport'),
);
const CaseDetailsReviewCommentPage = lazyPage(
  () => import('pages/CaseManagementPage/CasesPage/CaseDetailsReviewCommentPage'),
);
const AddEditNotePage = lazyPage(
  () => import('pages/CaseManagementPage/CasesPage/CaseDetailsPage/Notes/AddEditNotePage'),
);
const NoteDetailsPage = lazyPage(
  () => import('pages/CaseManagementPage/CasesPage/CaseDetailsPage/Notes/NoteDetailsPage'),
);
const CaseAddPage = lazyPage(() => import('pages/CaseManagementPage/CasesPage/CaseAddPage'));
const EditIntelligenceReport = lazyPage(
  () =>
    import('pages/CaseManagementPage/CasesPage/CaseDetailsPage/IntelligenceReport/EditIntelligenceReport'),
);
const IntelligenceReportDetailsPage = lazyPage(
  () =>
    import('pages/CaseManagementPage/CasesPage/CaseDetailsPage/IntelligenceReport/IntelligenceReportDetailsPage'),
);
const LegalEntityCreateLicenceVaryPage = lazyPage(
  () =>
    import('pages/LegalEntitiesPage/LegalEntityLicenceVaryPage/legalEntityCreateLicenceVaryPage'),
  'LegalEntityCreateLicenceVaryPage',
);
const LegalEntityCreateLicenceRenewPage = lazyPage(
  () =>
    import('pages/LegalEntitiesPage/LegalEntityLicenceRenewPage/legalEntityCreateLicenceRenewPage'),
  'LegalEntityCreateLicenceRenewPage',
);
const SystemFieldsConfigurationPage = lazyPage(
  () => import('pages/SystemSettingsPage/SystemFieldsConfigurationPage'),
  'SystemFieldsConfigurationPage',
);
const LicenceAuthoritiesPage = lazyPage(() => import('pages/LicenceAuthoritiesPage'));
const LicenceAuthorityEditPage = lazyPage(
  () => import('pages/LicenceAuthoritiesPage/LicenceAuthorityEditPage'),
);
const LicenceAuthorityCreatePage = lazyPage(
  () => import('pages/LicenceAuthoritiesPage/LicenceAuthorityCreatePage'),
);
const LicenceAuthorityPage = lazyPage(
  () => import('pages/LicenceAuthoritiesPage/LicenceAuthorityPage'),
);
const LicencePrintoutSettingsEdit = lazyPage(
  () => import('pages/LicenceConfigurationPage/LicencePrintoutSettingsEdit'),
  'LicencePrintoutSettingsEdit',
);
const LicenceAuthoritiesPrintoutSettingsPage = lazyPage(
  () => import('pages/LicenceAuthoritiesPage/LicenceAuthoritiesPrintoutSettingsPage'),
);
const LicenceAuthoritiesPrintoutSettingsEdit = lazyPage(
  () => import('pages/LicenceAuthoritiesPage/LicenceAuthoritiesPrintoutSettingsEdit'),
);
const LicenceAuthoritiesPrintoutSettingsDelete = lazyPage(
  () => import('pages/LicenceAuthoritiesPage/LicenceAuthoritiesPrintoutSettingsDelete'),
);
const LicenceAuthoritiesPrintoutSettingsAdd = lazyPage(
  () => import('pages/LicenceAuthoritiesPage/LicenceAuthoritiesPrintoutSettingsAdd'),
);

export const PageComponentTypes = {
  [EPageComponentTypes.AuthPage]: AuthPage,
  [EPageComponentTypes.ForgotPasswordPage]: ForgotPasswordPage,
  [EPageComponentTypes.ResetPasswordPage]: ResetPasswordPage,
  // @ts-expect-error: required by update
  [EPageComponentTypes.ResetPasswordLink]: ResetPasswordPage,
  [EPageComponentTypes.DashboardPage]: DashboardPage,
  [EPageComponentTypes.DashboardSearchResultsPage]: DashboardSearchResultsPage,
  [EPageComponentTypes.LegalEntitiesPage]: LegalEntitiesPage,
  // @ts-expect-error: required by update
  [EPageComponentTypes.LegalEntitiesExpand]: LegalEntitiesPage,
  [EPageComponentTypes.AddLegalEntityPage]: AddLegalEntityPage,
  [EPageComponentTypes.EditLegalEntityPage]: EditLegalEntityPage,
  [EPageComponentTypes.DeleteLegalEntityPage]: DeleteLegalEntityPage,
  [EPageComponentTypes.ViewLegalEntityPage]: ViewLegalEntityPage,
  [EPageComponentTypes.LegalEntityAddCommentPage]: LegalEntityAddCommentPage,
  [EPageComponentTypes.LegalEntityDeleteCommentPage]: LegalEntityDeleteCommentPage,
  [EPageComponentTypes.LegalEntityAddAddressPage]: LegalEntityAddAddressPage,
  [EPageComponentTypes.LegalEntityEditAddressPage]: LegalEntityEditAddressPage,
  [EPageComponentTypes.ViewLegalEntityAddressMapPage]: ViewLegalEntityAddressMapPage,
  [EPageComponentTypes.LegalEntityDeleteAddressPage]: LegalEntityDeleteAddressPage,
  [EPageComponentTypes.LegalEntityAddAttachmentPage]: LegalEntityAddAttachmentPage,
  [EPageComponentTypes.LegalEntityViewLicencePage]: LegalEntityViewLicencePage,
  [EPageComponentTypes.LegalEntityLicenceLinkWeaponPage]: LegalEntityLicenceLinkWeaponPage,
  [EPageComponentTypes.LegalEntityLicencePage]: LegalEntityLicencePage,
  [EPageComponentTypes.LegalEntityAddContactPage]: LegalEntityAddContactPage,
  [EPageComponentTypes.LegalEntityEditContactPage]: LegalEntityEditContactPage,
  [EPageComponentTypes.LegalEntityAddPreviousNamesSurnamesPage]:
    LegalEntityAddPreviousNamesSurnamesPage,
  [EPageComponentTypes.LegalEntityEditPreviousNamesSurnamesPage]:
    LegalEntityEditPreviousNamesSurnamesPage,
  [EPageComponentTypes.LegalEntityDeletePreviousNamesSurnamesPage]:
    LegalEntityDeletePreviousNamesSurnamesPage,
  [EPageComponentTypes.LegalEntityDeleteContactPage]: LegalEntityDeleteContactPage,
  [EPageComponentTypes.LegalEntityAddGroupPage]: LegalEntityAddGroupPage,
  [EPageComponentTypes.LegalEntityGroupFirearmSearchPage]: LegalEntityGroupFirearmSearchPage,
  [EPageComponentTypes.LegalEntityEditGroupPage]: LegalEntityEditGroupPage,
  [EPageComponentTypes.LegalEntityDeleteGroupPage]: LegalEntityDeleteGroupPage,
  [EPageComponentTypes.LegalEntityGroupDeleteFirearmPage]: LegalEntityGroupDeleteFirearmPage,
  [EPageComponentTypes.LegalEntityGroupDeleteAncillaryPage]:
    LegalEntityGroupDeleteAncillaryPage,
  [EPageComponentTypes.ViewLegalEntityGroupPage]: ViewLegalEntityGroupPage,
  [EPageComponentTypes.LegalEntityGroupAddFirearmPage]: LegalEntityGroupAddFirearmPage,
  [EPageComponentTypes.SearchForFRTFirearmPage]: SearchForFRTFirearmPage,
  [EPageComponentTypes.SearchForARTAncillaryPage]: SearchForARTAncillaryPage,
  [EPageComponentTypes.LegalEntityAddAncillaryPage]: LegalEntityAddAncillaryPage,
  [EPageComponentTypes.LegalEntityAddAncillaryGroupPage]: LegalEntityAddAncillaryGroupPage,
  [EPageComponentTypes.ViewLegalEntityAncillaryGroupPage]: ViewLegalEntityAncillaryGroupPage,
  [EPageComponentTypes.LegalEntityEditAncillaryGroupPage]: LegalEntityEditAncillaryGroupPage,
  [EPageComponentTypes.LegalEntityDeleteAncillariesGroupPage]:
    LegalEntityDeleteAncillariesGroupPage,
  [EPageComponentTypes.LegalEntityAddAncillaryGroupSearchPage]:
    LegalEntityAddAncillaryGroupSearchPage,
  [EPageComponentTypes.LegalEntityAddFirearmPage]: LegalEntityAddFirearmPage,
  [EPageComponentTypes.LegalEntityAddTransactionForGroupPage]:
    LegalEntityAddTransactionForGroupPage,
  [EPageComponentTypes.LegalEntityAddTransactionForAncillaryGroupPage]:
    LegalEntityAddTransactionForAncillaryGroupPage,
  [EPageComponentTypes.FRTFirearmDetailsPage]: FRTFirearmDetailsPage,
  [EPageComponentTypes.FRTDetailsPage]: FRTDetailsPage,
  [EPageComponentTypes.FRTAddCalibrePage]: FRTAddCalibrePage,
  [EPageComponentTypes.FRTEditCalibrePage]: FRTEditCalibrePage,
  [EPageComponentTypes.EditFRTPage]: FRTEditPage,
  [EPageComponentTypes.AddFRTPage]: FRTAddPage,
  [EPageComponentTypes.SelectLocationPage]: SelectLocationPage,
  [EPageComponentTypes.MoveTransactionPage]: MovedTransactionPage,
  [EPageComponentTypes.FirearmsPage]: FirearmsPage,
  [EPageComponentTypes.SaveFirearmsPresetPage]: SaveFirearmsPresetPage,
  [EPageComponentTypes.ViewRegisteredFirearmPage]: ViewRegisteredFirearmPage,
  [EPageComponentTypes.ViewRegisteredFirearmFromLicencePage]: ViewRegisteredFirearmPage,
  [EPageComponentTypes.EditRegisteredFirearmPage]: EditRegisteredFirearmPage,
  [EPageComponentTypes.DisableRegisteredFirearmPage]: DisableRegisteredFirearmPage,
  [EPageComponentTypes.ViewRegisteredFirearmAttachment]: ViewRegisteredFirearmAttachment,
  [EPageComponentTypes.RegisteredFirearmAddCommentPage]: RegisteredFirearmAddCommentPage,
  [EPageComponentTypes.RegisteredFirearmDeleteCommentPage]: RegisteredFirearmDeleteCommentPage,
  [EPageComponentTypes.RegisteredFirearmDeleteAttachmentPage]:
    RegisteredFirearmDeleteAttachmentPage,
  [EPageComponentTypes.RegisteredFirearmAddAttachmentPage]: RegisteredFirearmAddAttachmentPage,
  [EPageComponentTypes.RegisteredFirearmsMapPage]: RegisteredFirearmsMapPage,
  [EPageComponentTypes.RegisteredAncillariesMapPage]: RegisteredAncillariesMapPage,
  [EPageComponentTypes.SelectLegalEntityPage]: SelectLegalEntityPage,
  [EPageComponentTypes.AncillariesPage]: AncillariesPage,
  [EPageComponentTypes.AddAncillaries]: AddAncillariesReference,
  [EPageComponentTypes.DetailAncillaries]: DetailAncillariesReference,
  [EPageComponentTypes.DisableAncillary]: DisableAncillaryPage,
  [EPageComponentTypes.AncillaryDetails]: DetailAncillariesReference,
  [EPageComponentTypes.AccessoriesDeleteCommentPage]: AccessoriesDeleteCommentPage,
  [EPageComponentTypes.AccessoriesAddCommentPage]: AccessoriesAddCommentPage,
  [EPageComponentTypes.AccessoriesAddAttachmentPage]: AccessoriesAddAttachmentPage,
  [EPageComponentTypes.AccessoriesViewAttachmentPage]: AccessoriesAttachmentViewPage,
  [EPageComponentTypes.AccessoriesDeleteAttachmentPage]: AccessoriesDeleteAttachmentPage,
  [EPageComponentTypes.ComponentsDeleteCommentPage]: ComponentsDeleteCommentPage,
  [EPageComponentTypes.ComponentsAddCommentPage]: ComponentsAddCommentPage,
  [EPageComponentTypes.ComponentsAddAttachmentPage]: ComponentsAddAttachmentPage,
  [EPageComponentTypes.ComponentsViewAttachmentPage]: ComponentsAttachmentViewPage,
  [EPageComponentTypes.ComponentsDeleteAttachmentPage]: ComponentsDeleteAttachmentPage,
  [EPageComponentTypes.AmmunitionAddAttachmentPage]: AmmunitionAddAttachmentPage,
  [EPageComponentTypes.AmmunitionViewAttachmentPage]: AmmunitionAttachmentsViewPage,
  [EPageComponentTypes.AmmunitionDeleteAttachmentPage]: AmmunitionDeleteAttachmentPage,
  [EPageComponentTypes.AmmunitionDeleteCommentPage]: AmmunitionDeleteCommentPage,
  [EPageComponentTypes.AmmunitionAddCommentPage]: AmmunitionAddCommentPage,
  [EPageComponentTypes.DetailAccessories]: DetailAccessories,
  [EPageComponentTypes.DetailComponents]: DetailComponents,
  [EPageComponentTypes.DetailAmmunition]: DetailAmmunition,
  [EPageComponentTypes.EditAncillaries]: EditAncillariesReference,
  [EPageComponentTypes.EditAncillary]: EditAncillaryPage,
  [EPageComponentTypes.AncillariesAddTransactionPage]: AncillariesAddTransactionPage,
  [EPageComponentTypes.TransactionsPage]: TransactionsPage,
  [EPageComponentTypes.ViewTransactionPage]: ViewTransactionPage,
  [EPageComponentTypes.CancelTransactionPage]: CancelTransactionPage,
  [EPageComponentTypes.TransactionAddCommentPage]: TransactionAddCommentPage,
  [EPageComponentTypes.TransactionDeleteCommentPage]: TransactionDeleteCommentPage,
  [EPageComponentTypes.SaveTransactionPresetPage]: SaveTransactionPresetPage,
  [EPageComponentTypes.SaveLicencesPresetPage]: SaveLicencePresetPage,
  [EPageComponentTypes.UsersPage]: UsersPage,
  [EPageComponentTypes.AddUserPage]: AddUserPage,
  [EPageComponentTypes.EditUserPage]: EditUserPage,
  [EPageComponentTypes.GeneratePasswordUserPage]: GeneratePasswordUserPage,
  [EPageComponentTypes.ViewUserPage]: ViewUserPage,
  [EPageComponentTypes.EditUserStatusPage]: EditUserStatusPage,
  [EPageComponentTypes.ResetUserOfflineAuth]: ResetUserOfflineAuth,
  [EPageComponentTypes.AssignLESearchPage]: AssignLESearchPage,
  [EPageComponentTypes.AssignLEPage]: AssignLEPage,
  [EPageComponentTypes.DeleteAssignedLEPage]: DeleteAssignedLEPage,
  [EPageComponentTypes.RolesPage]: RolesPage,
  [EPageComponentTypes.DictionariesPage]: DictionariesPage,
  [EPageComponentTypes.LicencePage]: LicencePage,
  [EPageComponentTypes.LegalEntityLicenceVaryPage]: LegalEntityLicenceVaryPage,
  [EPageComponentTypes.LegalEntityCreateLicenceVaryPage]: LegalEntityCreateLicenceVaryPage,
  [EPageComponentTypes.LegalEntityCreateLicenceRenewPage]: LegalEntityCreateLicenceRenewPage,
  [EPageComponentTypes.LegalEntityLicenceRenewPage]: LegalEntityLicenceRenewPage,
  [EPageComponentTypes.ReplaceLicencePage]: ReplaceLicencePage,
  [EPageComponentTypes.ViewDictionaryPage]: ViewDictionaryPage,
  [EPageComponentTypes.EditDictionaryPage]: EditDictionaryValuePage,
  [EPageComponentTypes.AddDictionaryValuePage]: AddDictionaryValuePage,
  [EPageComponentTypes.EditRolePage]: EditRolePage,
  [EPageComponentTypes.ViewRolePage]: ViewRolePage,
  [EPageComponentTypes.AddRolePage]: AddRolePage,
  [EPageComponentTypes.DeleteRolePage]: DeleteRolePage,
  [EPageComponentTypes.AdministrationPage]: AdministrationPage,
  [EPageComponentTypes.GeneralLicenceSettingsPage]: GeneralLicenceSettingsPage,
  [EPageComponentTypes.LicenceAuthoritiesPage]: LicenceAuthoritiesPage,
  [EPageComponentTypes.AddLicenceAuthorityPage]: LicenceAuthorityCreatePage,
  [EPageComponentTypes.EditLicenceAuthorityPage]: LicenceAuthorityEditPage,
  [EPageComponentTypes.LicenceAuthorityPage]: LicenceAuthorityPage,
  [EPageComponentTypes.LicenceAuthoritiesPrintoutSettingsPage]:
    LicenceAuthoritiesPrintoutSettingsPage,
  [EPageComponentTypes.LicenceAuthoritiesPrintoutSettingsEdit]:
    LicenceAuthoritiesPrintoutSettingsEdit,
  [EPageComponentTypes.LicenceAuthoritiesPrintoutSettingsDelete]:
    LicenceAuthoritiesPrintoutSettingsDelete,
  [EPageComponentTypes.LicenceAuthoritiesPrintoutSettingsAdd]:
    LicenceAuthoritiesPrintoutSettingsAdd,
  [EPageComponentTypes.NotificationsSetupPage]: NotificationsSetupPage,
  [EPageComponentTypes.AuthenticationSetupPage]: AuthenticationSetupPage,
  [EPageComponentTypes.LogosSetupPage]: LogoSetupPage,
  [EPageComponentTypes.SystemFieldsConfigurationPage]: SystemFieldsConfigurationPage,
  [EPageComponentTypes.DocumentsGeneratingSetupPage]: DocumentsGeneratingSetupPage,
  [EPageComponentTypes.UnitsCurrencySetupPage]: UnitsCurrencySetupPage,
  [EPageComponentTypes.AuditLogPage]: AuditLogPage,
  [EPageComponentTypes.AuditLogViewPage]: AuditLogViewPage,
  [EPageComponentTypes.DateTimeSetupPage]: DateTimeSetupPage,
  [EPageComponentTypes.CustomFieldsPage]: CustomFieldsPage,
  [EPageComponentTypes.AddCustomFieldPage]: AddCustomFieldPage,
  [EPageComponentTypes.EditCustomFieldPage]: EditCustomFieldPage,
  [EPageComponentTypes.ToggleCustomFieldPage]: ToggleCustomFieldPage,
  [EPageComponentTypes.NotificationsPage]: NotificationsPage,
  [EPageComponentTypes.ViewNotificationPage]: ViewNotificationPage,
  [EPageComponentTypes.AccountPage]: AccountPage,
  [EPageComponentTypes.RemoveDevicePage]: RemoveDevicePage,
  [EPageComponentTypes.ChangePasswordPage]: ChangePasswordPage,
  [EPageComponentTypes.AccountEditPage]: EditAccountPage,
  [EPageComponentTypes.MyFiltersPage]: MyFiltersPage,
  [EPageComponentTypes.DeleteFilterPage]: DeleteFilterPage,
  [EPageComponentTypes.SavePresetPage]: SavePresetPage,
  [EPageComponentTypes.SaveAncillariesPresetPage]: SaveAncillariesPresetPage,
  [EPageComponentTypes.TableTestPage]: TableTestPage,
  [EPageComponentTypes.NotFoundPage]: NotFoundPage,
  [EPageComponentTypes.AccessDeniedPage]: AccessDeniedPage,
  [EPageComponentTypes.ServerErrorPage]: ServerErrorPage,
  [EPageComponentTypes.StyleGuidePage]: StyleGuidePage,
  [EPageComponentTypes.ApiKeysPage]: ApiKeysPage,
  [EPageComponentTypes.AddApiKeyPage]: AddApiKeyPage,
  [EPageComponentTypes.EditApiKeyPage]: EditApiKeyPage,
  [EPageComponentTypes.ViewApiKeyPage]: ViewApiKeyPage,
  [EPageComponentTypes.DeleteApiKeyPage]: DeleteApiKeyPage,
  [EPageComponentTypes.StartLicencePage]: StartLicencePage,
  [EPageComponentTypes.DeleteUserPage]: DeleteUserPage,
  [EPageComponentTypes.LicenceConfigurationPage]: LicenceConfigurationPage,
  [EPageComponentTypes.AddLicenceTemplatePage]: AddLicenceTemplatePage,
  [EPageComponentTypes.EditLicenceTemplatePage]: EditLicenceTemplatePage,
  [EPageComponentTypes.LicenceTemplatePage]: LicenceTemplatePage,
  [EPageComponentTypes.LicencePrintoutSettings]: LicencePrintoutSettingsEdit,

  [EPageComponentTypes.LicenceTemplateApplicationProcessPage]:
    LicenceTemplateApplicationProcessPage,
  [EPageComponentTypes.AddLicenceTemplateApplicationProcessPage]:
    LicenceTemplateAddApplicationProcessPage,
  [EPageComponentTypes.EditLicenceTemplateApplicationProcessPage]:
    LicenceTemplateEditApplicationProcessPage,

  [EPageComponentTypes.CaseDetailsPage]: CaseDetailsPage,
  [EPageComponentTypes.CaseDetailsReviewCommentPage]: CaseDetailsReviewCommentPage,
  [EPageComponentTypes.CaseAddPage]: CaseAddPage,
  [EPageComponentTypes.LegalEntityCaseAddPage]: CaseAddPage,
  [EPageComponentTypes.CaseManagementPage]: CaseManagementPage,

  [EPageComponentTypes.CaseNoteAddPage]: AddEditNotePage,
  [EPageComponentTypes.LegalEntityCaseNoteAddPage]: AddEditNotePage,
  [EPageComponentTypes.CaseNotePage]: NoteDetailsPage,
  [EPageComponentTypes.LegalEntityCaseNotePage]: NoteDetailsPage,
  [EPageComponentTypes.CaseNoteEditPage]: AddEditNotePage,
  [EPageComponentTypes.LegalEntityCaseNoteEditPage]: AddEditNotePage,
  [EPageComponentTypes.AddIntelligenceReportResult]: AddIntelligenceReport,
  [EPageComponentTypes.LegalEntityAddIntelligenceReportResult]: AddIntelligenceReport,
  [EPageComponentTypes.CaseIntelligenceReportPage]: IntelligenceReportDetailsPage,
  [EPageComponentTypes.LegalEntityCaseIntelligenceReportPage]: IntelligenceReportDetailsPage,
  [EPageComponentTypes.CaseIntelligenceReportEditPage]: EditIntelligenceReport,
  [EPageComponentTypes.LegalEntityCaseIntelligenceReportEditPage]: EditIntelligenceReport,

  [EPageComponentTypes.CalendarPage]: CalendarPage,
  [EPageComponentTypes.LicencesPage]: LicencesTabsPage,
  [EPageComponentTypes.PrintoutBatchDetails]: PrintoutBatchDetails,
  [EPageComponentTypes.PrintoutDetails]: PrintoutDetails,
  [EPageComponentTypes.ManageImagesTemplate]: ManageImagesTemplate,
};
